import { NumericFormat, NumberFormatValues } from 'react-number-format';
import { useFormContext } from 'react-hook-form';
import React, { useEffect } from 'react';
import TextField from '@mui/material/TextField';
interface InputProps {
    name: string;
    prefix?: string;
    suffix?: string;
    onChange?: () => void;
    disabled?: boolean;
    size?: 'small' | 'medium';
}
export default function NumericInput(props: InputProps) {
    const { register, getValues, setValue, watch } = useFormContext();

    useEffect(() => {
        console.log(props.name);
    }, [watch(props.name)]);

    return (
        <NumericFormat
            {...props}
            id={props.name}
            {...register(props.name)}
            decimalSeparator=","
            size={props.size ? props.size : 'medium'}
            value={getValues(props.name)}
            onValueChange={(values: NumberFormatValues) => {
                setValue(props.name, values.value);
            }}
            onChange={props.onChange}
            thousandSeparator="."
            valueIsNumericString
            prefix={props.prefix}
            suffix={props.suffix}
            decimalScale={2}
            disabled={props.disabled}
            customInput={TextField}
        />
    );
}
